export function formatFileSize(bytes?: number | null): string {
  if (!bytes || bytes < 0) {
    return '0 B';
  }

  const units = ['B', 'KB', 'MB', 'GB'];
  const unitIndex = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / Math.pow(1024, unitIndex);

  return `${Number(value.toFixed(unitIndex === 0 ? 0 : 2))} ${units[unitIndex]}`;
}
